/* eslint-disable no-plusplus */
/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import EditIcon from '@material-ui/icons/Edit';
import DescriptionIcon from '@material-ui/icons/Description';
import moment from 'moment-timezone';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';

// import  from '@material-ui/core/CheckBox';
import { styled, Checkbox } from '@material-ui/core';

import Button from '@material-ui/core/Button';

import Select from 'react-select';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import _ from 'lodash';

import {
  // TimePicker,
  // KeyboardDatePicker,
  MuiPickersUtilsProvider,
  DateTimePicker,
  // KeyboardTimePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import locale from 'date-fns/locale/pt-BR';
import FlashContext from '../../../components/contexts/FlashContext';
import Loading from '../../../components/loading/Loading';
import api from '../../../service/axios/api';


const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: 3,
  width: 16,
  height: 16,
  boxShadow:
    theme.palette.mode === 'dark'
      ? '0 0 0 1px rgb(16 22 26 / 40%)'
      : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
  backgroundImage:
    theme.palette.mode === 'dark'
      ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
      : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:
      theme.palette.mode === 'dark'
        ? 'rgba(57,75,89,.5)'
        : 'rgba(206,217,224,.5)',
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: '#137cbd',
  backgroundImage:
    'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 16,
    height: 16,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#106ba3',
  },
});

const optionsStatus = [
  {
    label: 'Aguardando cartão',
    value: 'AwaitingCard',
  },
  {
    label: 'Processando',
    value: 'Processing',
  },
  {
    label: 'Aguardando pagamento',
    value: 'AwaitingPayment',
  },
  {
    label: 'Processado',
    value: 'Processed',
  },
  {
    label: 'Aguardando cartão finalizar',
    value: 'AwaitingCardRelease',
  },
  {
    label: 'Cancelado',
    value: 'Canceled',
  },
  {
    label: 'Recebido',
    value: 'Received',
  },
  {
    label: 'Rejeitado',
    value: 'Rejected',
  },
  {
    label: 'Processamento automático',
    value: 'AutoProcessing',
  },
  {
    label: 'Aguardando conciliação',
    value: 'AwaitingConciliation',
  },
  {
    label: 'Aguardando processamento',
    value: 'AwaitingProcessing',
  },
  {
    label: 'Criado',
    value: 'Created',
  },
];

const customStylesEdit = {
  control: provided => ({
    ...provided,
    // width: 105,
    height: 40,
    borderRadius: 10,
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  option: provided => ({
    ...provided,
  }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
};

function createData(
  id,
  order,
  status,
  value,
  created,
  date_processed,
  date_conciliation,
  name,
  cpf,
  cardStatus,
  proxy,
  cardNumber,
  flag,
  file,
) {
  return {
    id,
    order,
    status,
    value,
    created,
    date_processed,
    date_conciliation,
    name,
    cpf,
    cardStatus,
    proxy,
    cardNumber,
    flag,
    file,
  };
}

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  table: {
    minWidth: 1100,
  },
});

const StyledTableCell = withStyles(() => ({
  head: {
    // backgroundColor: theme.palette.common.black,
    // color: theme.palette.common.white,
  },
  body: {
    fontSize: 12,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

// eslint-disable-next-line no-unused-vars
export function ClientsTable({
  docs,
  setDocs,
  page,
  setPage,
  itens,
  setItens,
  total,
  searchData,
}) {
  const classes = useStyles();
  // const [page, setPage] = React.useState(0);
  // const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [open, setOpen] = useState(false);
  const [openAll, setOpenAll] = useState(false);
  const [months, setMonths] = useState([])
  const [dateConc, setDateConc] = useState(null);
  const [dateProc, setDateProc] = useState(null);

  const [rows, setRows] = useState([]);

  const [dataEdit, setDataEdit] = useState();
  const [typeSelected, setTypeSelected] = useState({
    label: 'tipo',
    value: 'value',
  });

  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const { notifyError, notifySuccess } = useContext(FlashContext);

  const isSelected = id =>
    selected.indexOf(selected.find(e => e === id)) !== -1;

  const monthsString = (value) => {
    switch(value){
      case 0: return 'Janeiro'
      case 1: return 'Fevereiro'
      case 2: return 'Março'
      case 3: return 'Abril'
      case 4: return 'Maio'
      case 5: return 'Junho'
      case 6: return 'Julho'
      case 7: return 'Agosto'
      case 8: return 'Setembro'
      case 9: return 'Outubro'
      case 10: return 'Novembro'
      case 11: return 'Dezembro'
      default: return ''
    }
  }

  useEffect(()=>{
    const data = new Date();
    const listMonths = []
    for(let x = 0; x < 3; x++ ){
      data.setMonth(data.getMonth() - (x === 0 ? 0 : 1))
      const res = data.getMonth()
      listMonths.push(monthsString(res))
    }
    listMonths.reverse()
    setMonths(listMonths)

  },[])

  const returnContract = (contracts) => {
    switch(contracts?.length){
      case 0:
        return '';
      case 1:
        return contracts[0].type === 'Card' ? 'Cartão' : 'Tranferência';
      case 2:
        return `${contracts[0].type === 'Card' ? 'Cartão' : 'Tranferência'} / ${contracts[1].type === 'Card' ? 'Cartão' : 'Tranferência'}`;
      default: return ''
    }
  }

  const returnMonthResult = (contract) =>{
    const data = new Date();
    const month1 = {index: 0, valueC : 'R$ 0,00', valueT : 'R$ 0,00', countC: 'QTD: 0', countT: 'QTD: 0'};
    const month2 = {index: 0, valueC : 'R$ 0,00', valueT : 'R$ 0,00', countC: 'QTD: 0', countT: 'QTD: 0'};
    const month3 = {index: 0, valueC : 'R$ 0,00', valueT : 'R$ 0,00', countC: 'QTD: 0', countT: 'QTD: 0'};

    for(let x = 0; x < 3; x++ ){
      data.setMonth(data.getMonth() - (x === 0 ? 0 : 1))
      if(x === 0){
        month1.index = data.getMonth()
      }else if(x === 1){
        month2.index = data.getMonth()
      }else if(x ===2){
        month3.index = data.getMonth()
      }
    }

    contract?.forEach((c) => {
      c?.orders?.forEach((o) => {
        if(Number(moment(o.data).format('MM')) === month1.index){
          if(c.type === 'Card'){
            month1.valueC = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(o.sum)
            month1.countC = `QTD: ${o.count}`
          }else{
            month1.valueT = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(o.sum)
            month1.countT = `QTD: ${o.count}`
          }
        }else if(Number(moment(o.data).format('MM')) === month2.index){
          if(c.type === 'Card'){
            month2.valueC = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(o.sum)
            month2.countC = `QTD: ${o.count}`
          }else{
            month2.valueT = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(o.sum)
            month2.countT = `QTD: ${o.count}`
          }
        }else if(Number(moment(o.data).format('MM')) === month3.index){
          if(c.type === 'Card'){
            month3.valueC = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(o.sum)
            month3.countC = `QTD: ${o.count}`
          }else{
            month3.valueT = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(o.sum)
            month3.countT = `QTD: ${o.count}`
          }
        }
      })
    })

    return {month1: contract.length > 1 ? `${contract[0].type === 'Card' ? `${month2.valueC  }/${  month2.valueT}` : `${month2.valueT  }/${month2.valueC}`}` : `${contract[0].type === 'Card' ? month2.valueC : month2.valueT}`,
      month2: contract.length > 1 ? `${contract[0].type === 'Card' ? `${month1.valueC  }/${  month1.valueT}` : `${month1.valueT  }/${month1.valueC}`}` : `${contract[0].type === 'Card' ? month1.valueC : month1.valueT}`,
      month3: contract.length > 1 ? `${contract[0].type === 'Card' ? `${month3.valueC  }/${  month3.valueT}` : `${month3.valueT  }/${month3.valueC}`}` : `${contract[0].type === 'Card' ? month3.valueC : month3.valueT}`,
      count1: contract.length > 1 ? `${contract[0].type === 'Card' ? `${month2.countC  }/${  month2.countT}` : `${month2.countT  }/${month2.countC}`}` : `${contract[0].type === 'Card' ? month2.countC : month2.countT}`,
      count2: contract.length > 1 ? `${contract[0].type === 'Card' ? `${month1.countC  }/${  month1.countT}` : `${month1.countT  }/${month1.countC}`}` : `${contract[0].type === 'Card' ? month1.countC : month1.countT}`,
      count3: contract.length > 1 ? `${contract[0].type === 'Card' ? `${month3.countC  }/${  month3.countT}` : `${month3.countT  }/${month3.countC}`}` : `${contract[0].type === 'Card' ? month3.countC : month3.countT}`}
  }

  const returnLasOrder = (contract) => {
    let lastOrder = ''
    contract?.forEach((c) => {
      c?.orders?.forEach((o) => {
        if(lastOrder === ''){
      lastOrder = o.lastOrder
    }else if(moment(o.lastOrder).isAfter(moment(lastOrder))){
        lastOrder = o.lastOrder
      }
      })})
    return lastOrder
  }

  useEffect(() => {
    const list = [];
    setSelected([]);
    docs.forEach(doc => {
      list.push({
        cnpj: doc?.cnpj,
        name: doc?.name,
        ...returnMonthResult(doc?.contracts),
        contract: returnContract(doc?.contracts),
        lastOrder: returnLasOrder(doc?.contracts)
      });
    });
    setRows(list);
  }, [docs]);

  useEffect(() => {
    if (dataEdit) {
      switch (dataEdit.status) {
        case 'AwaitingCard':
          setTypeSelected({
            label: 'Aguardando cartão',
            value: 'AwaitingCard',
          });
          break;
        case 'Processing':
          setTypeSelected({
            label: 'Processando',
            value: 'Processing',
          });
          break;
        case 'AwaitingPayment':
          setTypeSelected({
            label: 'Aguardando pagamento',
            value: 'AwaitingPayment',
          });
          break;
        case 'Processed':
          setTypeSelected({
            label: 'Processado',
            value: 'Processed',
          });
          break;
        case 'AwaitingCardRelease':
          setTypeSelected({
            label: '',
            value: 'AwaitingCardRelease',
          });
          break;
        case 'Canceled':
          setTypeSelected({
            label: 'Cancelado',
            value: 'Canceled',
          });
          break;
        case 'Received':
          setTypeSelected({
            label: 'Recebido',
            value: 'Received',
          });
          break;
        case 'Rejected':
          setTypeSelected({
            label: 'Rejeitado',
            value: 'Rejected',
          });
          break;
        case 'AutoProcessing':
          setTypeSelected({
            label: 'Processamento automático',
            value: 'AutoProcessing',
          });
          break;
        case 'AwaitingConciliation':
          setTypeSelected({
            label: 'Aguardando conciliação',
            value: 'AwaitingConciliation',
          });
          break;
        case 'AwaitingProcessing':
          setTypeSelected({
            label: 'Aguardando processamento',
            value: 'AwaitingProcessing',
          });
          break;
        case 'Created':
          setTypeSelected({
            label: 'Criado',
            value: 'Created',
          });
          break;
        default:
          console.log('Deu erro');
      }
      if (dataEdit.processed && dataEdit.processed !== '') {
        setDateProc(new Date(dataEdit.processed));
      }
      if (dataEdit.conciliation && dataEdit.conciliation !== '') {
        setDateProc(new Date(dataEdit.conciliation));
      }
    }
  }, [dataEdit]);

  useEffect(() => {
    if (!open) {
      setDateProc(null);
      setDateConc(null);
    }
  }, [open]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setItens(+event.target.value);
    setPage(0);
  };

  const edit = data => {
    if (selected.length > 1) {
      setOpenAll(true);
    } else {
      setDataEdit(data);
      setOpen(true);
    }
  };

  const editOrder = e => {
    e.preventDefault();
    setLoading(true);
    const orig = _.cloneDeep(docs);

    api.order
      .updateItemAdmin(dataEdit.id, typeSelected.value, dateProc, dateConc)
      .then(() => {
        const found = orig.indexOf(orig.find(el => el.id === dataEdit.id));
        if (found) {
          const dest = orig.find(el => el.id === dataEdit.id);
          dest.date_conciliation = dateConc && moment.utc(dateConc);
          dest.date_processing = dateProc && moment.utc(dateProc);
          dest.status = typeSelected.value;
          orig.splice(found, 1, dest);
          setDocs(orig);
        }

        setLoading(false);
        setOpen(false);
        notifySuccess('Registro atualizado com sucesso');
        // console.log(res);
      })
      .catch(err => {
        setLoading(false);
        notifyError('Erro ao atualizar. Tente novamente.');
        console.log(err);
      });
  };

  const editOrderAll = e => {
    e.preventDefault();

    setLoading(true);
    // const orig = _.cloneDeep(docs);

    api.order
      .updateBatchItemAdmin(selected, typeSelected.value, dateProc, dateConc)
      .then(() => {
        searchData();
        setSelected([]);
        setLoading(false);
        setOpenAll(false);
        notifySuccess('Registros atualizados com sucesso');
      })
      .catch(err => {
        setLoading(false);
        notifyError('Erro ao atualizar. Tente novamente.');
        console.log(err);
      });
  };

  const returnColor = (data) => {
    if(data === ''){
      return 'red'
    }

    const hoje = moment(new Date())
    const ultima = moment(data)
    const dias = hoje.diff(ultima, 'days');

    if(dias <= 30){
      return ''
    // eslint-disable-next-line no-else-return
    }else if(dias > 30 && dias <= 45){
      return 'yellow'
    }else if(dias > 45 && dias <= 60){
      return '#fd7e14'
    }else {
      return 'red'
    }
  }

  return (
    <>
      <Paper className={classes.root}>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow>
                {/* <StyledTableCell style={{ width: 10, margin: 0, padding: 0 }}>
                  <Checkbox
                    // color="primary"
                    checkedIcon={<BpCheckedIcon />}
                    icon={<BpIcon />}
                    onChange={handleSelectAllClick}
                    indeterminate={
                      selected.length > 0 && selected.length < rows.length
                    }
                    checked={rows.length > 0 && selected.length === rows.length}
                    // onChange={e => handleClick(e, row)}
                    inputProps={{
                      'aria-label': 'select all desserts',
                    }}
                  />
                </StyledTableCell> */}
                <StyledTableCell >CNPJ</StyledTableCell>
                <StyledTableCell >Empresa</StyledTableCell>
                {months.map((m) => (
                  <StyledTableCell >{m}</StyledTableCell>
                ))}
                <StyledTableCell >Contrato</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, i) => {
                const isItemSelected = isSelected(row.id);
                return (
                  <StyledTableRow key={i} style={{backgroundColor: returnColor(row.lastOrder)}}>
                    {/* <StyledTableCell
                      style={{ width: 10, margin: 0, padding: 0 }}
                    >
                      <Checkbox
                        // color="primary"
                        checkedIcon={<BpCheckedIcon />}
                        icon={<BpIcon />}
                        // indeterminate={numSelected > 0 && numSelected < rowCount}
                        // checked={
                        //   rows.length > 0 && selected.length === rows.length
                        // }
                        checked={isItemSelected}
                        onChange={e => handleClick(e, row)}
                        inputProps={{
                          'aria-label': 'select all desserts',
                        }}
                      />
                    </StyledTableCell> */}
                    <StyledTableCell component="th" scope="row" style={{color: returnColor(row.lastOrder) === 'red' && 'white', fontWeight: returnColor(row.lastOrder) === 'red' && 'bold'}}>
                      {row.cnpj}
                    </StyledTableCell>
                    <StyledTableCell style={{color: returnColor(row.lastOrder) === 'red' && 'white', fontWeight: returnColor(row.lastOrder) === 'red' && 'bold'}}>
                      {row.name}
                    </StyledTableCell>
                    <StyledTableCell style={{color: returnColor(row.lastOrder) === 'red' && 'white', fontWeight: returnColor(row.lastOrder) === 'red' && 'bold'}}><div><div>{row.count1}</div>{row.month1}</div></StyledTableCell>
                    <StyledTableCell style={{color: returnColor(row.lastOrder) === 'red' && 'white', fontWeight: returnColor(row.lastOrder) === 'red' && 'bold'}}><div><div>{row.count2}</div>{row.month2}</div></StyledTableCell>
                    <StyledTableCell style={{color: returnColor(row.lastOrder) === 'red' && 'white', fontWeight: returnColor(row.lastOrder) === 'red' && 'bold'}}><div><div>{row.count3}</div>{row.month3}</div></StyledTableCell>
                    <StyledTableCell style={{color: returnColor(row.lastOrder) === 'red' && 'white', fontWeight: returnColor(row.lastOrder) === 'red' && 'bold'}}>{row.contract}</StyledTableCell>

                    {/* 
style={{color: returnColor(row.lastOrder) === 'red' && 'white', fontWeight: returnColor(row.lastOrder) === 'red' && 'bold'}}
style={{color: returnColor(row.lastOrder) === 'red' && 'white', fontWeight: returnColor(row.lastOrder) === 'red' && 'bold'}}
style={{color: returnColor(row.lastOrder) === 'red' && 'white', fontWeight: returnColor(row.lastOrder) === 'red' && 'bold'}} */}
                    {/* <StyledTableCell>{row.name}</StyledTableCell>
                    <StyledTableCell>{row.cpf}</StyledTableCell>
                    <StyledTableCell>{row.cardStatus}</StyledTableCell>
                    <StyledTableCell>{row.proxy}</StyledTableCell>
                    <StyledTableCell>{row.cardNumber}</StyledTableCell>
                    <StyledTableCell>{row.flag}</StyledTableCell>
                    <StyledTableCell>
                      {row.file?.map(f => (
                        <DescriptionIcon
                          style={{ cursor: 'pointer' }}
                          onClick={() => window.open(f.gcs_file)}
                        />
                      ))}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      <EditIcon
                        style={{ cursor: 'pointer' }}
                        onClick={() => edit(row)}
                      />
                    </StyledTableCell> */}
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          // count={rows.length}
          count={total}
          rowsPerPage={itens}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      {/* MODAL DE EDIÇÃO */}
      <Dialog
        onClose={() => setOpen(!open)}
        open={open}
        fullWidth
        maxWidth="sm"
      >
        <Loading open={loading} msg="Atualizando registro..." />
        <DialogTitle id="simple-dialog-title">Edição do pedido</DialogTitle>
        <form onSubmit={editOrder}>
          <Grid
            container
            spacing={1}
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              padding: 20,
            }}
          >
            <Grid item xs={12} sm={12}>
              <Grid
                container
                spacing={1}
                style={{
                  paddingRight: 20,
                  paddingLeft: 20,
                }}
              >
                <Grid item xs={12} sm={12}>
                  <h6>Pedido</h6>
                  <TextField
                    disabled
                    size="small"
                    variant="outlined"
                    fullWidth
                    defaultValue={dataEdit && dataEdit.order}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid
                container
                spacing={1}
                style={{
                  paddingRight: 20,
                  paddingLeft: 20,
                }}
              >
                <Grid item xs={12} sm={6}>
                  <h6>Data processamento</h6>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={locale}
                    // className={classes.margin}
                  >
                    <DateTimePicker
                      fullWidth
                      clearable
                      size="small"
                      value={dateProc}
                      inputVariant="outlined"
                      placeholder="Data processamento"
                      onChange={dat => setDateProc(dat)}
                      autoOk
                      format="dd/MM/yyyy HH:mm"
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <h6>Data conciliação</h6>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={locale}
                    // className={classes.margin}
                  >
                    <DateTimePicker
                      fullWidth
                      clearable
                      size="small"
                      value={dateConc}
                      inputVariant="outlined"
                      placeholder="Data conciliação"
                      onChange={dat => setDateConc(dat)}
                      autoOk
                      format="dd/MM/yyyy HH:mm"
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid
                container
                spacing={1}
                style={{
                  paddingRight: 20,
                  paddingLeft: 20,
                }}
              >
                <Grid item xs={12} sm={12}>
                  <h6>Status</h6>
                  <Select
                    fullWidth
                    styles={customStylesEdit}
                    classNamePrefix="select"
                    placeholder="Tipo"
                    value={typeSelected}
                    onChange={setTypeSelected}
                    isSearchable={false}
                    options={optionsStatus}
                    menuPortalTarget={document.body}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <DialogActions>
            <Button onClick={() => setOpen(false)} color="secondary">
              Cancelar
            </Button>
            <Button type="submit" color="primary" variant="contained" autoFocus>
              Salvar alterações
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Dialog
        onClose={() => setOpenAll(!openAll)}
        open={openAll}
        fullWidth
        maxWidth="sm"
      >
        <Loading open={loading} msg="Atualizando registros..." />
        <DialogTitle id="simple-dialog-title">Edição em massa</DialogTitle>
        <form onSubmit={editOrderAll}>
          <Grid
            container
            spacing={1}
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              padding: 20,
            }}
          >
            <Grid item xs={12} sm={12}>
              <Grid
                container
                spacing={1}
                style={{
                  paddingRight: 20,
                  paddingLeft: 20,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid
                container
                spacing={1}
                style={{
                  paddingRight: 20,
                  paddingLeft: 20,
                }}
              >
                <Grid item xs={12} sm={6}>
                  <h6>Data processamento</h6>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={locale}
                    // className={classes.margin}
                  >
                    <DateTimePicker
                      fullWidth
                      clearable
                      size="small"
                      value={dateProc}
                      inputVariant="outlined"
                      placeholder="Data processamento"
                      onChange={dat => setDateProc(dat)}
                      autoOk
                      format="dd/MM/yyyy HH:mm"
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <h6>Data conciliação</h6>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={locale}
                    // className={classes.margin}
                  >
                    <DateTimePicker
                      fullWidth
                      clearable
                      size="small"
                      value={dateConc}
                      inputVariant="outlined"
                      placeholder="Data conciliação"
                      onChange={dat => setDateConc(dat)}
                      autoOk
                      format="dd/MM/yyyy HH:mm"
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid
                container
                spacing={1}
                style={{
                  paddingRight: 20,
                  paddingLeft: 20,
                }}
              >
                <Grid item xs={12} sm={12}>
                  <h6>Status</h6>
                  <Select
                    fullWidth
                    styles={customStylesEdit}
                    classNamePrefix="select"
                    placeholder="Tipo"
                    value={typeSelected}
                    onChange={setTypeSelected}
                    isSearchable={false}
                    options={optionsStatus}
                    menuPortalTarget={document.body}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <DialogActions>
            <Button onClick={() => setOpenAll(false)} color="secondary">
              Cancelar
            </Button>
            <Button type="submit" color="primary" variant="contained" autoFocus>
              Salvar alterações
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
